function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import DashCard from '@rd-web-markets/shared/dist/dashboards/components/DashCard';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
const ClaimGroupProjectTypesPieChart = _ref => {
  let {
    dashboardData,
    ...props
  } = _ref;
  const labels = ['R&D', 'Non R&D', 'TBC'];
  const series = [dashboardData?.project_types?.rnd || 0, dashboardData?.project_types?.non_rnd || 0, dashboardData?.project_types?.tbc || 0];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "Project Types"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px'
    }
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default ClaimGroupProjectTypesPieChart;